export default "__VITE_ASSET__tXjF$PmB__"